import { useEffect, useState } from "react";

function fmt(seconds) {
  if (seconds == null) return null;
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return [h, m, sec].map((n) => String(n).padStart(2, "0")).join(":");
}

export default function Countdown({ initialSeconds, onExpire, className = "" }) {
  const [remaining, setRemaining] = useState(
    initialSeconds == null ? null : Math.max(0, initialSeconds)
  );

  useEffect(() => {
    if (initialSeconds == null) {
      setRemaining(null);
      return;
    }
    setRemaining(Math.max(0, initialSeconds));
    const t = setInterval(() => {
      setRemaining((r) => {
        if (r == null) return r;
        if (r <= 1) {
          clearInterval(t);
          onExpire?.();
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [initialSeconds, onExpire]);

  if (remaining == null) return null;

  if (remaining <= 0)
    return (
      <span className={`font-mono-tactical text-xs uppercase tracking-[0.25em] text-white/50 ${className}`}>
        Drop closed
      </span>
    );

  const text = fmt(remaining);
  return (
    <span
      className={`font-mono-tactical font-semibold tracking-[0.18em] ${className}`}
      data-testid="countdown"
    >
      {text}
    </span>
  );
}
